import React from 'react'
import { useSelector } from 'react-redux'

import { isEmpty } from 'lodash-es'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import CaseloadManagementContainer from './CaseloadManagementContainer'
import ProviderPerformance from './ProviderPerformance'
import { BCC_COACH_SUPERVISOR_ROLES, employmentTypes, LT_COACH_ROLES } from '../../common/constants/appConstants'
import { hasRole } from '../../common/utils/utils'
import { getAuthEmploymentStatus, getAuthRoles, getAuthSupervisor, getAuthUser } from '../../data/auth/authSelectors'

export const ProviderCaseload: React.FC = () => {
  const userRoles = useSelector(getAuthRoles)
  const employmentStatus = useSelector(getAuthEmploymentStatus)
  const supervisor = useSelector(getAuthSupervisor)
  const authUser = useSelector(getAuthUser)
  const authUserCountry = authUser?.country
  const isUSProvider = authUserCountry && authUserCountry === 'US'

  const { showNewCaseloadDashboardProviders } = useFlags()

  const newCaseloadDashboardVersion =
    hasRole(userRoles, LT_COACH_ROLES) &&
    employmentStatus &&
    [employmentTypes.FULL_TIME, employmentTypes.PART_TIME].includes(employmentStatus) &&
    isUSProvider
  const isBCCSupervisor =
    supervisor && !isEmpty(supervisor.roles) && hasRole(supervisor.roles, BCC_COACH_SUPERVISOR_ROLES)
  if (newCaseloadDashboardVersion && showNewCaseloadDashboardProviders && !isBCCSupervisor) {
    return <CaseloadManagementContainer />
  }

  return <ProviderPerformance />
}

export default ProviderCaseload
